import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Badge, Skeleton, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { useSingleConsultationQuery } from 'app/services/edpApiV1/consultations';
import { dataForTableUserConsultations, dataForUserConsultations, sortingDate } from 'shared/helpers/utils';
import {
  TSingleConsultationPreparedData,
  TSingleConsultationPreparedTableData,
} from 'shared/types/consultations.types';
import Chat from 'features/chat';
import SendMessage from 'features/sendMessage';
import { useAppSelector } from 'app/store';
import { viewerModel } from 'entities/viewer';
import { useIndicators } from 'features/indicators';
import ConsultationUserForm from '../consultationsForms/consultationUserForm';
import style from './index.module.scss';

/**
 * @page Consultations user
 */

const columns: ColumnsType<TSingleConsultationPreparedTableData> = [
  {
    title: '№',
    dataIndex: 'id',
    key: 'key',
    width: 140,
  },
  {
    title: 'Дата',
    dataIndex: 'created',
    key: 'created',
    sorter: (a, b) => sortingDate(a.created, b.created),
  },
  {
    title: 'Тема',
    dataIndex: 'topic',
    key: 'topic',
  },
  {
    title: 'ФИО',
    dataIndex: 'fio',
    key: 'fio',
  },
  {
    title: 'Должность',
    dataIndex: 'position',
    key: 'position',
  },
  {
    title: 'Подразделение',
    dataIndex: 'division',
    key: 'division',
  },
  {
    title: 'Статус',
    dataIndex: 'status',
    key: 'status',
    render: status => (
      <span>
        <Badge status={status.type} />
        {status.text}
      </span>
    ),
  },
];

const ConsultationsUser = () => {
  const [dataConsultations, setDataConsultations] = useState<TSingleConsultationPreparedData[] | []>([]);
  const tableData = useRef<TSingleConsultationPreparedTableData[]>();
  const { id } = useParams();

  const accountInfo = useAppSelector(viewerModel.me.selectors.selectViewerProfile);
  const {
    data: consultation,
    isLoading,
    refetch: consultationRefetch,
    isFetching,
    isSuccess,
  } = useSingleConsultationQuery(Number(id));

  useEffect(() => {
    if (consultation) {
      const dataConsultation = dataForUserConsultations(consultation);
      const dataForTable = dataForTableUserConsultations(consultation);
      tableData.current = dataForTable;
      setDataConsultations(dataConsultation);
    }
  }, [consultation]);

  useIndicators(isSuccess, isFetching);

  return (
    <>
      <div className={style.wrap}>
        {isLoading ? (
          <Skeleton active />
        ) : (
          <>
            <Table scroll={{ x: true }} dataSource={tableData.current} columns={columns} pagination={false} bordered />
            {dataConsultations && (
              <ConsultationUserForm dataConsultations={dataConsultations} consultationRefetch={consultationRefetch} />
            )}
          </>
        )}
      </div>

      <Chat id={Number(id)} />

      {accountInfo.id === consultation?.consultant.id ? <SendMessage id={id} /> : null}
    </>
  );
};

export default ConsultationsUser;
